<h1 mat-dialog-title>Cadastrar Fornecedor</h1>
<mat-divider></mat-divider>
<div mat-dialog-content>

    <form [formGroup]="fornecedorForm">
        <div class="row">
            <div class="col-auto">
                <h1 class="customH1">Informações Gerais</h1>
            </div>
            <div class="col-sm">
                <hr />
            </div>
        </div>

        <div class="borda">
            <div class="row">
                <div class="col-sm">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Razão Social</mat-label>
                        <input type="text" matInput formControlName="razaoSocial" required maxlength="100">
                        <mat-error *ngIf="f.razaoSocial.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Nome Fantasia</mat-label>
                        <input type="text" matInput formControlName="nomeFantasia" required maxlength="100">
                        <mat-error *ngIf="f.nomeFantasia.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-sm">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>CNPJ</mat-label>
                        <input type="text" matInput formControlName="cnpj" [textMask]="{mask: maskCNPJ, guide:false}"
                            required>
                        <mat-error *ngIf="f.cnpj.errors?.required">
                            Campo obrigatório
                        </mat-error>
                        <mat-error *ngIf="!f.cnpj.errors?.cnpjVerdadeiro">
                            CNPJ informado não é válido
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Inscrição Estadual</mat-label>
                        <input type="text" matInput formControlName="inscricaoEstadual" required maxlength="50">
                        <mat-hint align="end">Em caso de isenção, informar: "Isento"</mat-hint>
                        <mat-error *ngIf="f.inscricaoEstadual.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Telefone</mat-label>
                        <input type="text" matInput formControlName="telefone" [textMask]="{mask: maskTelefone}"
                            (ngModelChange)="onChangeTel($event, true)" required>
                        <mat-error *ngIf="f.telefone.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Telefone Secundário</mat-label>
                        <input type="text" matInput formControlName="telefoneSecundario"
                            [textMask]="{mask: maskTelefone2}" (ngModelChange)="onChangeTel($event, false)">
                    </mat-form-field>
                </div>

                <div class="col-sm">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Responsável</mat-label>
                        <input type="text" matInput formControlName="responsavel" required maxlength="100">
                        <mat-error *ngIf="f.responsavel.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-sm">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Observação</mat-label>
                        <input type="text" matInput formControlName="observacao" maxlength="100">
                        <mat-error *ngIf="f.observacao.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>


        <div class="row mt-4">
            <div class="col-auto">
                <h1 class="customH1">Endereço</h1>
            </div>
            <div class="col-sm">
                <hr />
            </div>
        </div>

        <div class="borda">
            <div class="row">
                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" style="width: 150px;">
                        <mat-label>CEP</mat-label>
                        <input type="text" matInput formControlName="cep" required maxlength="10"
                            (ngModelChange)="buscarCEP()" [textMask]="{mask: maskCEP, guide:false}">
                        <mat-error *ngIf="f.cep.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-auto col-md-8">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Logradouro</mat-label>
                        <input type="text" matInput formControlName="logradouro" required maxlength="100">
                        <mat-error *ngIf="f.logradouro.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Número</mat-label>
                        <input type="text" matInput formControlName="numero" required maxlength="20">
                        <mat-error *ngIf="f.numero.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-auto col-md-3">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Complemento</mat-label>
                        <input type="text" matInput formControlName="complemento" maxlength="100">
                        <mat-error *ngIf="f.complemento.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-xs-auto col-md-4">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Bairro</mat-label>
                        <input type="text" matInput formControlName="bairro" required maxlength="30">
                        <mat-error *ngIf="f.bairro.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-xs-auto col-md-3">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Cidade</mat-label>
                        <input type="text" matInput formControlName="cidade" required maxlength="30">
                        <mat-error *ngIf="f.cidade.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-xs-auto col-md-2">
                    <mat-form-field appearance="outline" [floatLabel]="'always'" style="width: 100px;">
                        <mat-label>UF</mat-label>
                        <input type="text" matInput formControlName="uf" required maxlength="2">
                        <mat-error *ngIf="f.uf.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-sm">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Referência</mat-label>
                        <input type="text" matInput formControlName="referencia" maxlength="180">
                        <mat-error *ngIf="f.referencia.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

    </form>

    <mat-divider></mat-divider>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
        <button mat-flat-button color="warn" (click)="cancelar()">
            <mat-icon>clear</mat-icon> Cancelar
        </button>
        <button mat-flat-button color="primary" (click)="cadastrar()">
            <mat-icon>check</mat-icon> Cadastrar
        </button>
    </section>

</div>